module.exports = __webpack_public_path__ + "img/pi-4-9.365db3f9.jpg";